// extracted by mini-css-extract-plugin
export default {"main":"about_main__JXdXZ","sec2":"about_sec2__hconf"};